<template>
	<app-content class="h-panel">
		<div class="h-panel-bar"><span class="h-panel-title">凭证列表</span></div>
		<div class="margin-right-left margin-top">
			<account-date-choose v-model="accountDate"/>
			<!-- 时间：<a-range-picker :locale="locale" v-model="dateQueryRange" format="YYYY-MM-DD" @change="onTimeChangeQuery" /> &nbsp; -->
			<div class="float-right">
				<template v-if="User.role!=='View' && currentAccountSets.voucherReviewed">
					<Button :loading="loading" @click="audit">审核</Button>
					<Button :loading="loading" @click="cancelAudit">取消审核</Button>
				</template>
				<DropdownMenu button @click="trigger" :datas="param">打印</DropdownMenu>
				<template v-if="User.role!=='View'">
					<Button :loading="loading" @click="finishingOffNo">整理断号</Button>
					<Button :loading="loading" @click="batchDelete">批量删除</Button>
					<Button :loading="loading" @click="showBatchCreate">批量生成凭证</Button>
					<Button :loading="loading" @click="doUpload">
						<input ref="file" type="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
						 style="display: none" @change="fileChangeYQ($event)">
						导入凭证
					</Button> 
					<!-- <Button :loading="loading" @click="doUpload">
						<input ref="fileYQ" type="file" accept="application/vnd.ms-excel" style="display: none" @change="fileChange($event)">
						导入凭证
					</Button> -->
				</template>
			</div>
		</div>
		<div class="h-panel-body">
			<table class="header">
				<tr>
					<th style="width: 50px"><input :checked="checkAll" type="checkbox" @click="checkAll=!checkAll"></th>
					<td style="width: 450px">摘要</td>
					<td>科目</td>
					<td align="right" style="width: 130px">借方金额</td>
					<td align="right" style="width: 130px">贷方金额</td>
				</tr>
			</table>
			<table v-if="!datas.length">
				<tr>
					<td colspan="5" class="text-center padding">暂无数据</td>
				</tr>
			</table>
			<table class="details" v-for="data in datas" :key="data.id">
				<tr class="details-header">
					<th style="width: 50px"><input :class="{'display':data._checked}" v-model="data._checked" type="checkbox"></th>
					<td colspan="2">日期：{{data.voucherDate}} 凭证字号：{{data.word}}-{{data.code}}</td>
					<td colspan="2" class="actions" align="right">
						<router-link v-if="data.auditMemberId" tag="span" :to="{name:'VoucherForm',params:{voucherId:data.id}}">查看</router-link>
						<a :href="`/api/pfd/voucher?id=${data.id}`" target="_blank">打印</a>
						<router-link v-if="User.role!=='View'" tag="span" :to="{name:'VoucherForm',params:{voucherId:data.id}}">修改</router-link>
						<span v-if="User.role!=='View'" @click="remove(data)">删除</span>
						<i v-if="data.auditMemberId" class="h-icon-completed green-color" v-tooltip content="已审核"></i>
					</td>
				</tr>
				<tr v-for="d in data.details" :key="d.id">
					<th></th>
					<td style="width: 450px">
						{{d.summary}}
						<template v-if="d.subject&&d.num&&d.price">
							(数量:{{d.num}}<span class="dark4-color">{{d.subject.unit}}</span>，单价:{{d.price}}<span class="dark4-color">元</span>)
						</template>
					</td>
					<td>{{d.subjectName}}</td>
					<td align="right" style="width: 130px">{{d.debitAmount|numFormat}}</td>
					<td align="right" style="width: 130px">{{d.creditAmount|numFormat}}</td>
				</tr>
				<tr class="font-bold">
					<td></td>
					<td>合计</td>
					<td>{{data.debitAmount|dxMoney}}</td>
					<td align="right">{{data.debitAmount|numFormat}}</td>
					<td align="right">{{data.creditAmount|numFormat}}</td>
				</tr>
			</table>
			<Pagination v-model="pagination" @change="currentChange" layout="pager" small align="center"/>
		</div>
		<Modal title="选择记账记录" v-model="batchVisible"  cancelText="取消" okText="确认" :width="960"
				@ok="cashDailyOk"  @cancel="batchVisible=false">
					<div slot="header">选择摘要</div>
					账号： <a-select :value="actId"  v-model="actId" style="width:200px;padding-right:5px;" :options="actSelectData" @change="loadCashDailyList" > </a-select>
					时间：<a-range-picker :locale="locale"  @change="onTimeChange" />
					<Table :datas="CashDailyData" :border="true" ref="cdtb"
						style="width:950px;margin-top:5px;" :height="300" :checkbox="true" >
						<TableItem title="出纳编号" prop="cashierNo"></TableItem>
						<TableItem title="日期" prop="billTime"></TableItem>
						<TableItem title="摘要" prop="abstractName"></TableItem>
						<TableItem title="借（收入）金额" prop="incomeAmount"></TableItem>
						<TableItem title="贷（支出）金额" prop="payAmount"></TableItem>
						<TableItem title="操作人" prop="personName"></TableItem>
						<TableItem title="备注" prop="remark"></TableItem> 
					</Table>
					<div slot="footer">
						<Button color="primary" @click="cashDailyOk">确认</Button>
						<Button @click="batchVisible=false">关闭</Button> 
					</div>
			</Modal>
	</app-content>
</template>

<script>
	import Qs from "qs";
	import locale from 'ant-design-vue/lib/locale-provider/zh_CN';
	import moment from 'moment'
	import {mapState} from 'vuex' 
	// import { startOfMonth, endOfMonth } from 'date-fns';
	import 'moment/locale/zh-cn';
	moment.locale('zh-cn');

	export default {
		name: "Voucher",
		data() {
			return {
				datas: [],
				dateQueryRange:[
					moment().startOf('month').format('YYYY-MM-DD'),
					moment().endOf('month').format('YYYY-MM-DD')
				],
				locale, 
				accountDate: null,
				pagination: {
					page: 1,
					total: 0
				},
				startTimeQuery: moment().startOf('month').format('YYYY-MM-DD'),
				endTimeQuery:moment().endOf('month').format('YYYY-MM-DD'),
				startTime:undefined,
				endTime:undefined,
				batchVisible:false,
				actSelectData:[],
				CashDailyData:[],
				selectionData:[],
				actId:0, 
				voucherDate:undefined,
				loading: false,
				checkAll: false,
				param: [{title: '打印全部', key: 'printAll'}, {title: '打印选中', key: 'printCheck'}]
			};
		},
		watch: {
			checkAll(nval) {
				let data = Array.from(this.datas);
				data.forEach(val => val._checked = nval);
				this.datas = data;
			},
			accountDate() {
				this.pagination.page = 1;
				this.loadList(); 
				this.loadDefaultSubject();
			}
		},
		created() {  
			this.loadList();
		},
		computed: {
			...mapState(['User', 'currentAccountSets']),
			date() {
				return moment(this.accountDate);
			}
		},
		methods: {
			currentChange() {
				this.loadList();
			},
			trigger(key) {
				this[key].call(this);
			},
			printAll() {
				let param = Qs.stringify({year: this.date.year(), month: this.date.month() + 1}, {indices: false});
				window.open(`/api/pfd/voucher?${param}`);
			},
			printCheck() {
				let checked = this.datas.filter(value => value._checked);
				if (checked.length) {
					let param = Qs.stringify({id: checked.map(value => value.id)}, {indices: false});
					window.open(`/api/pfd/voucher?${param}`);
				} else {
					this.$Message("未选择记录");
				}
			},
			loadList() {
				//按月版本
				this.$api.voucher.list(
					{
						voucher_year: this.date.year(), 
						voucher_month: this.date.month() + 1, 
						page: this.pagination.page,
						// startTime:this.startTimeQuery,
						// endTime:this.endTimeQuery
						}
					).then(({data}) => {
					this.datas = data.records;
					this.pagination = {
						page: data.current,
						size: data.size,
						total: data.total
					}
				})
				//按时间版本
				// this.$api.voucher.listQuery(
				// 	{ 
				// 		accountSetsId:this.User.accountSetsId,
				// 		page: this.pagination.page,
				// 		startTime:this.startTimeQuery,
				// 		endTime:this.endTimeQuery
				// 		}
				// 	).then(({data}) => {
				// 	this.datas = data.records;
				// 	this.pagination = {
				// 		page: data.current,
				// 		size: data.size,
				// 		total: data.total
				// 	}
				// })
			},
			remove(data) {
				this.$Confirm("确认删除?").then(() => {
					this.$api.voucher.delete(data.id).then(() => {
						this.loadList();
					})
				});
			},
			finishingOffNo() {
				this.loading = true;
				this.$api.voucher.finishingOffNo({year: this.date.year(), month: this.date.month() + 1}).then(() => {
					this.loadList();
				}).finally(() => {
					this.loading = false
				});
			},
			batchDelete() {
				let checked = this.datas.filter(value => value._checked);
				if (checked.length) {
					this.$Confirm("确认删除?").then(() => {
						this.loading = true;
						this.$api.voucher.batchDelete({checked: checked.map(value => value.id), year: this.date.year(), month: this.date.month() + 1}).then(() => {
							this.loadList();
						}).finally(() => {
							this.loading = false
						});
					});
				}
			},
			audit() {
				let checked = this.datas.filter(value => value._checked);
				if (checked.length) {
					this.$Confirm("亲，确认要审核吗?").then(() => {
						this.loading = true;
						this.$api.voucher.audit({checked: checked.map(value => value.id), year: this.date.year(), month: this.date.month() + 1}).then(() => {
							this.loadList();
							this.$Message("审核成功！");
						}).finally(() => {
							this.loading = false;
						});
					});
				} else {
					this.$Message("未选择记录");
				}
			},
			cancelAudit() {
				let checked = this.datas.filter(value => value._checked);
				if (checked.length) {
					this.$Confirm("亲，确认要取消审核吗?").then(() => {
						this.loading = true;
						this.$api.voucher.cancelAudit({checked: checked.map(value => value.id), year: this.date.year(), month: this.date.month() + 1}).then(() => {
							this.loadList();
							this.$Message("取消审核成功！");
						}).finally(() => {
							this.loading = false;
						});
					});
				} else {
					this.$Message("未选择记录");
				}
			},
			doUpload() {
				this.$refs.file.click();
			},
			fileChange(e) {
				if (this.$refs.file.files.length) {
					let formData = new FormData();
					formData.append('file', this.$refs.file.files[0]);
					this.loading = true;
					this.$api.voucher.import(formData).then(({data}) => {
						if (data) {
							this.accountDate = data;
						}
						this.$store.dispatch('init');
						this.$Message("亲,导入成功~");
					}).finally(() => {
						this.loading = false;
					});

					this.$refs.file.value = "";
				}
			}, 
			fileChangeYQ(e) {
				if (this.$refs.file.files.length) {
					let formData = new FormData();
					formData.append('file', this.$refs.file.files[0]);
					formData.append('accountSetsId', this.User.accountSetsId);
					this.loading = true;
					this.$api.voucher.importyq(formData).then(({data}) => {
						if (data) {
							this.accountDate = data;
						}
						this.$store.dispatch('init');
						this.$Message("亲,导入成功~");
					}).finally(() => {
						this.loading = false;
					});

					this.$refs.file.value = "";
				}
			}, 
			loadDefaultSubject(){
				this.$api.voucher.getSubjectByCode('1122').then(data=>{
					if(data.code==200){
						this.defaultSubject=data.data;
					}
					// console.log(this.defaultSubject);
				})
			},
			//时间筛选
			onTimeChange(date, dateString){
				this.startTime = dateString[0];
				this.endTime = dateString[1];
				this.loadCashDailyList();
			},
			//列表时间筛选
			onTimeChangeQuery(date, dateString){
				this.startTimeQuery = dateString[0];
				this.endTimeQuery = dateString[1];
				this.loadList();
			},
			//查询记账记录
			loadCashDailyList(){ 
				if(this.actId == undefined || this.actId == 0){
					var accountSetsId = this.User.accountSetsId;
					this.$api.cashier.act_list(accountSetsId).then(({ data }) => { 
						if(data!=undefined && data.length>0){
							for(var i = 0;i<data.length;i++){
								var ops = {
									value:data[i].id,
									label:data[i].name
								}
								this.actSelectData.push(ops);
							} 
							this.actId= data[0].id;
						}
					});
				}
				var parmas = { 
					accountSetsId:accountSetsId,
					actId:this.actId
				} 
				if(this.startTime=='' || this.endTime==''){
					var parmas = { 
					accountSetsId:accountSetsId,
					actId:this.actId
					} 
				}else{
					var parmas = { 
						accountSetsId:accountSetsId,
						actId:this.actId,
						startTime:this.startTime,
						endTime:this.endTime
					} 
				}
				this.$api.cashier.cd_nobindlist(parmas).then(({ data }) => {  
                    this.CashDailyData = data;
				})
			},
			//显示记账记录
			showBatchCreate(){
				this.batchVisible =true;
				this.loadCashDailyList();
			},
			//批量生成
			cashDailyOk(){
				this.selectionData = this.$refs.cdtb.getSelection();
				if(this.selectionData!=undefined && this.selectionData.length>0){
					var datasList = new Array();  
					this.selectionData.forEach(item=>{
						var datas = new Array(); 
						var obj = {
							auditMemberId:0,
							word: "记",
							remark:"",
							voucherDate: item.billTime ,
							carryForward:false, 
						};
						var v = {
							auxiliary:[],
							auxiliaryTitle:"",
							creditAmount:item.payAmount,
							debitAmount:item.incomeAmount,
							// direction:"借",
							summary:item.abstractName,
							subjectCode:item.bindSubjectCode,
							subjectId:item.bindSubjectId,
							subjectName:item.bindSubjectCode+"-"+item.bindSubjectName,

						}
						var v2 = {
							auxiliary:[],
							auxiliaryTitle:"",
							creditAmount:item.incomeAmount,
							debitAmount:item.payAmount,
							// direction:"借",
							summary:item.abstractName,
							subjectCode:this.defaultSubject.code,
							subjectId:this.defaultSubject.id,
							subjectName:this.defaultSubject.code+"-"+this.defaultSubject.name,
						} 
						if(v.debitAmount > 0){
							datas.push(v);
							datas.push(v2);
						}else{
							datas.push(v2);
							datas.push(v);
						}
						 
						obj.details = datas;
						datasList.push(obj); 
					})
					this.$api.voucher.batchSave(datasList).then(res => {
						this.loadList();
						if(res.code==200){
							this.batchVisible = false;
						}
						
					})  
				}

			}
		}
	};
</script>
<style lang='less' scoped>
	.h-panel-body {
		table {
			width: 100%;
			border-collapse: collapse;

			td {
				padding: 7px;
			}

			&.header {
				background-color: @primary-color;
				color: white;
			}
		}

		.details {
			font-size: 12px;
			margin: 15px 0;
			border: 1px solid @gray2-color;

			.actions {
				text-align: right;
				padding-right: 20px;

				span, a {
					display: none;
				}
			}

			input {
				display: none;

				&.display {
					display: inline-block;
				}
			}

			&-header {
				background-color: @gray3-color;
				color: @dark3-color;
			}

			td, th {
				border-bottom: 1px solid @gray2-color;
			}

			tr:hover:not(.details-header) {
				background-color: #dff7df;
				cursor: pointer;
			}

			&:hover {
				box-shadow: 0 0 10px 0 #dadada;
				border-color: #dadada;

				.actions {
					span, a {
						display: inline-block;
					}
				}

				input {
					display: inline-block;
				}
			}
		}
	}
</style>